export default "__VITE_ASSET__e6d952cf__"